{
  "05bd04ad273c5704": "{{count}} min tarde",
  "06183a1704302fd0": "Revelar SSN",
  "069d7e9d898e4d81": "ID del trabajador",
  "0e3b8409d3390f10": "Este correo electrónico ya está en uso por otro trabajador.",
  "12d4885ac31f81d2": "Ver perfil del trabajador",
  "1449d5fb47172cac": "Copiar correo electrónico",
  "17251b2b0d826547": "Correo electrónico ya asignado",
  "19766ed6ccb2f4a3": "Cancelar",
  "1c30873ebfe024a3": "Abrir perfil de trabajador en conflicto",
  "1f8184153cb31c0c": "{{miles}} millas de distancia",
  "257c8051763d5f71": "Compartir credenciales",
  "26d5f8d94008a3b5": "No hay habilidades listadas aún",
  "2dee151577ec46d9": "Error al crear la credencial",
  "2ebd3eee0ba59ac5": "Abre el perfil del trabajador en conflicto y elimina o actualiza el correo electrónico antes de intentar de nuevo.",
  "3040c8e717b2f1c4": "Ver todas las visitas",
  "34959850195f221e": "Habilidades del trabajador",
  "460b3a7da007b7af": "Chat",
  "4703fd70dfd54415": "ETA",
  "4cef6ea5f6f442a1": "Actualizado {{ago}}",
  "4e952b41752d7990": "ETA en Tiempo Real del Trabajador",
  "4efca0d10c5feb8e": "Acerca de",
  "58c687242ef4a408": "Copiar ID del trabajador",
  "594015196a5f8bbd": "Llegó",
  "59a733f98dcb56f5": "Ocultar SSN",
  "5d9471f0b6fe6ebe": "Llegando tarde",
  "5efe4e47c6f5f7b1": "{{feet}} pies de distancia",
  "5f1a2542e4e4ca5e": "Próximas",
  "5f7905f8f05f92ab": "La ETA en tiempo real está disponible una vez que el profesional está en camino.",
  "63dceb8800b2dd4a": "Teléfono",
  "66d0f523a379b2de": "Habilidades",
  "67d6056ee9847bae": "Cerrar perfil del trabajador",
  "6be36ca49ee85210": "Faltante",
  "712da63171e0c9de": "Desbloquear",
  "72bbae008b725622": "Número de teléfono ya asignado",
  "769f89083fef5866": "Hubo un error al cargar el SSN de este trabajador. Intente de nuevo más tarde.",
  "791eeab186dff7be": "En la instalación",
  "7b4339cf860e01a6": "Calificaciones",
  "7db0470e986eabd5": "Documentos del trabajador",
  "7ded289ec39c7cd4": "Descargar credencial",
  "81421485e4fa5111": "No hay otros turnos",
  "82b062f1b5d11be7": "Ver todos los turnos",
  "8794836f7f6f7de0": "No se pudo cargar el perfil del trabajador.",
  "87cd0f2528b0314b": "Ver todos los documentos",
  "8d4da37e5ca89045": "No hay visitas próximas.",
  "8e5c93a68c8af09d": "{{count}} min temprano",
  "920e413c7d411b61": "Estado",
  "9334611a1a15bf72": "Número de teléfono en conflicto",
  "937d7af2b0a4d271": "nombre tmz",
  "9513b74847be3719": "No hay visitas pasadas.",
  "9671347571bf8b17": "Cerrar visitas programadas",
  "969ccbd3cf6300ec": "Correo electrónico",
  "9924deb0b3d22bee": "Visitas Programadas",
  "a2e197a272fd5b1c": "Abre el perfil del trabajador en conflicto y elimina o actualiza el número de teléfono antes de intentar de nuevo.",
  "a6b48d9a9a3aabd2": "A tiempo",
  "a9a90d2fb18f2c5c": "La hora de inicio",
  "aa32d0536bab7e63": "Sin visitas aún",
  "adb9935aefa97d3e": "Asignado a otro trabajador",
  "b4e929d8bcfe0418": "Documentos",
  "b522e0c2b9b83ef7": "No hay turnos reservados aún.",
  "b7bdf7a2d6e73e58": "Distancia",
  "c17c7df1213d835a": "Este número de teléfono ya está en uso por otro trabajador.",
  "c363496546214eb6": "Selecciona el rol para que el profesional cree la credencial",
  "c8ae57613e6c105c": "Ocultar todos los turnos",
  "c8df66c5fe3f97d0": "Cerrar diálogo",
  "ca1530e8d7017547": "Pasadas",
  "d5d6b83a02cc8d54": "Copiar número de teléfono",
  "d696a35bdd1883da": "Perfil",
  "d7d98b9629d60ef6": "No se encontró un rol elegible para crear una credencial.",
  "e5ca7c2158feb265": "Correo electrónico en conflicto",
  "e6284f231417b888": "Error al cargar documentos.",
  "f16c49174aa5a90e": "No hay documentos para mostrar",
  "f3314dc78a3e0b64": "Turnos reservados"
}
